import axios from 'axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';

export function addHomeworkToFavourite(userId, homeworkId) {
    const url = `${API_URL}/favouritehomework/users/${userId}/homework/${homeworkId}`;
    return {
        types: [types.ADD_HOMEWORK_TO_FAVOURITE, types.ADD_HOMEWORK_TO_FAVOURITE_SUCCESS, types.ADD_HOMEWORK_TO_FAVOURITE_FAILURE],
        promise: axios.post(url)
    };
}

export function removeHomeworkFromFavourite(userId, homeworkId) {
    const url = `${API_URL}/favouritehomework/users/${userId}/homework/${homeworkId}`;
    return {
        types: [types.REMOVE_HOMEWORK_FROM_FAVOURITE, types.REMOVE_HOMEWORK_FROM_FAVOURITE_SUCCESS, types.REMOVE_HOMEWORK_FROM_FAVOURITE_FAILURE],
        promise: axios.delete(url)
    };
}

export function getFavouriteHomework(userId) {
    const url = `${API_URL}/favouritehomework/users/${userId}`;
    return {
        types: [types.GET_FAVOURITE_HOMEWORK, types.GET_FAVOURITE_HOMEWORK_SUCCESS, types.GET_FAVOURITE_HOMEWORK_FAILURE],
        promise: axios.get(url)
    };
}
